export default "data:image/gif;base64,R0lGODlhEgAMAPEBAP8AAP///+Xl5QAAACH5BAAAAAAALAAAAAASAAwAAAIghC15yxffonlBRmobtoL67yXgSAnMljlQqlbstL6JaRUAOw=="